/* eslint-disable import/prefer-default-export */
export enum Role {
  DistrictAdmin = 'districtAdmin',
  SchoolAdmin = 'schoolAdmin',
  Teacher = 'teacher',
  Student = 'student',
  Parent = 'Mentor',
}
